import React from 'react';
import { TrendingUp } from 'lucide-react';

function StatCard({ stat, onClick, isActive }) {
  // Extract theme with defaults to prevent crashes if theme isn't provided
  const { bg, border, badge, shadow, inner } = stat.theme || {
    bg: 'bg-white',
    border: 'border-gray-100',
    badge: 'bg-gray-800',
    shadow: 'shadow-gray-200',
    inner: 'shadow-[inset_0px_0px_10px_rgba(0,0,0,0.05)]'
  };

  return (
    <div 
      onClick={onClick}
      className={`relative w-[210px] h-[180px] ${bg} ${border} border-2 rounded-[24px] p-4 flex flex-col items-center justify-center transition-all duration-300 hover:scale-[1.02] hover:shadow-xl shrink-0 group shadow-md ${inner} ${shadow} cursor-pointer ${isActive ? 'ring-4 ring-teal-500 shadow-xl' : ''}`}
    >
      {/* Icon Wrapper - simplified for custom SVGs */}
      <div className="relative mb-1 transform transition-transform group-hover:rotate-6">
        {stat.icon}
      </div>

      {/* Label and Value */}
      <div className="text-center space-y-0.5 mt-[-4px]">
        <p className="text-[12px] font-extrabold text-gray-500 uppercase tracking-[0.05em]">
          {stat.label}
        </p>
        <div className="flex items-baseline justify-center gap-1">
          <span className="text-[34px] font-[900] text-gray-900 tracking-tight leading-none">
            {stat.value}
          </span>
          <span className="text-[12px] font-bold text-gray-400">leads</span>
        </div>
      </div>

      {/* Trend Pill (optional) */}
      {stat.trend ? (
        <div className="mt-4 flex items-center gap-1 bg-[#D1FAE5] px-3 py-1 rounded-full border border-[#A7F3D0]">
          <TrendingUp className="w-3 h-3 text-[#059669]" />
          <span className="text-[11px] font-black text-[#059669]">{stat.trend}</span>
        </div>
      ) : (
        /* Empty space to keep vertical alignment consistent if no trend exists, 
           or we can just let it flex-center */
        <div className="h-6 mt-4" />
      )}
    </div>
  );
}

export default StatCard;